module.exports = __webpack_public_path__ + "static/img/3183.d4777418.jpg";